import { Theme } from '@mui/material';

import FormHelperText from './FormHelperText';
import IconButton from './IconButton';
import Input from './Input';
import Chip from './Chip';
import Button from './Button';
import Paper from './Paper';
import MenuItem from './MenuItem';
import AppBar from './AppBar';
import Link from './Link';
import ListItemIcon from './ListItemIcon';
import ListItemButton from './ListItemButton';
import Tooltip from './Tooltip';
import Drawer from './Drawer';
import CssBaseline from './CssBaseline';
import Card from './Card';
import ImageListItem from './ImageListItem';
import Toolbar from './Toolbar';
import Dialog from './Dialog';
import Autocomplete from './Autocomplete';
import Accordion from './Accordion';
import Table from './Table';
import Tab from './Tab';
import FormControlLabel from './FormControlLabel';
import Skeleton from './Skeleton';
import Container from './Container';
import Typography from './Typography';
import Radio from './Radio';
import Modal from './Modal';
import ToggleButtonGroup from './ToggleButtonGroup';
import ToggleButton from './ToggleButton';
import Checkbox from './Checkbox';
import AvatarGroup from './AvatarGroup';
import FormLabel from './FormLabel';

export default function ComponentsOverrides(theme: Theme) {
  return Object.assign(
    IconButton(theme),
    Input(theme),
    FormHelperText(),
    Chip(theme),
    Typography(),
    ToggleButtonGroup(theme),
    ToggleButton(theme),
    Checkbox(theme),
    Radio(theme),
    // TODO: TEMP is here till we migrate all of them, below ones are the one that we need to migrate fully
    Button(theme),
    Paper(theme),
    MenuItem(theme),
    AppBar(theme),
    Link(theme),
    ListItemIcon(theme),
    ListItemButton(theme),
    Tooltip(theme),
    Drawer(theme),
    CssBaseline(theme),
    Card(theme),
    ImageListItem(theme),
    Toolbar(),
    Dialog(),
    Autocomplete(),
    Accordion(theme),
    Table(theme),
    Tab(theme),
    FormControlLabel(theme),
    Skeleton(theme),
    Container(theme),
    Accordion(theme),
    Modal(theme),
    AvatarGroup(),
    FormLabel(),
  );
}
